import React from "react";
import { useI18n } from "@/contexts/I18nContext";

function LegalPage({ nsKey, testId }) {
  const { dict } = useI18n();
  const doc = dict[nsKey];
  return (
    <main data-testid={testId} className="bg-white">
      <div className="mx-auto max-w-4xl px-4 sm:px-8 lg:px-12 py-16 lg:py-24">
        <p className="font-mono text-xs uppercase tracking-widest text-[#059669]">
          {doc.updated}
        </p>
        <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-[#0A192F] leading-tight">
          {doc.title}
        </h1>
        <p className="mt-6 text-base text-[#334155] leading-relaxed">
          {doc.intro}
        </p>
        <div className="mt-10 space-y-8">
          {doc.sections.map((s, i) => (
            <section
              key={i}
              data-testid={`${testId}-section-${i}`}
              className="border-l-2 border-[#059669] pl-6"
            >
              <h2 className="font-heading text-xl font-semibold text-[#0A192F]">
                {s.heading}
              </h2>
              <p className="mt-3 text-sm sm:text-base text-[#334155] leading-relaxed">
                {s.body}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}

export function PrivacyPolicy() {
  return <LegalPage nsKey="privacy" testId="page-privacy" />;
}
export function CookiePolicy() {
  return <LegalPage nsKey="cookiesPolicy" testId="page-cookies" />;
}
export function TermsConditions() {
  return <LegalPage nsKey="terms" testId="page-terms" />;
}
